module.exports = __webpack_public_path__ + "static/media/14_l_kover_0_82.96.3ca27cbd.png";